module.exports = Object.freeze({
  baseUrl: 'https://intellicommand.jll.com/intellicommand/api/icMobileApp',
  username : 'tech.ahead.mobile',
  password : 'RW5LD-US3GM-4LRPF',
  messageShowTime : 3500,
});
